import { Injectable } from '@angular/core';
import { unregisterApplication } from 'single-spa';

interface IFormatNumber {
  clearValue: string;
  format: string;
}

@Injectable()

/**
 * Definición de la clase HelpersService, clase con funcionen de ayuda
 *
 * *HelpersService class definition, class with helper functions*
 *
 * @type {class}
 */
export class HelpersService {

  /**
   * Función para comparar dos fechas
   *
   * *Function to compare two dates*
   *
   * @type {function}
   * @param {string} d1
   * @param {string} d2
   * @returns {number}
   */
  compareDates(d1: string, d2: string): number {
    const date1 = d1.split('/');
    const date2 = d2.split('/');
    const date1UTC = Date.UTC(+date1[2], + date1[1] - 1, +date1[0]);
    const date2UTC = Date.UTC(+date2[2], + date2[1] - 1, +date2[0]);

    return Math.floor((date1UTC - date2UTC) / (1000 * 60 * 60 * 24));
  }

  /**
   * Convierte un string de versión a un número entero
   *
   * *Converts a version string to int number*
   * @param {string} version
   * @returns {number}
   */
  versionToNumber(version: string) {
    return parseInt(version.replace(/\./g, ''), 10);
  }

  /**
   * Pone array de datos enviados dentro de un string
   *
   * *Puts a data array sent inside an string*
   * @param {string} text
   * @param {string[]}args
   * @returns {string}
   */
  stringFormat(text: string, ...args: string[]): string {

    return text.replace(/{(\d+)}/g, (match, number) => {
      return typeof args[number] !== 'undefined' ? args[number] : match;
    });
  }

  currency(value: string, chunkLength: number = 3, chunkDelimiter: string = '.'): IFormatNumber {
    const newValue = this.clearValue(value);
    const regex = `\\d(?=(\\d{${chunkLength}})+$)`;
    let result = newValue.replace(new RegExp(regex, 'g'), `$&${chunkDelimiter}`);

    const zeroValidation = result;
    if (Number(zeroValidation) < 0.01) {
      result = '0';
    }
    return { format: `$${result.trim()}`, clearValue: newValue };
  }

  clearValue(value: string) {
    return value.toString().replace(/\D/g, '').replace(/^0+/, '').substring(0, 12);
  }

  /**
   * Convierte una variable en formato date en un campo valido apra vcl-date-picker
   *
   * *Converts date variable to vcl-datePicker valid variable*
   * @param {Date} date
   */
  formatingVclDate(date: Date) {
    return date.toISOString().slice(0, 10).split('-').reverse().join('/');
  }

  scrollToTop() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  /**
   * Convierte un texto a CamelCase sin espacios
   *
   * *Converts to CamelCase without spaces*
   * @param {string} text
   * @param {boolean} upper
   * @returns {string}
   */
  parseCamelCaseForIds(text: string, upper: boolean): string {
    const FIRST_WORD = 0;
    const SECOND_WORD = 1;
    const FIRST_LETTER = 0;
    const SECOND_LETTER = 1;
    const newText = text.split(' ');

    for (let i = SECOND_WORD; i < newText.length; i++) {
      newText[i] = newText[i].charAt(FIRST_LETTER).toUpperCase() + newText[i].slice(SECOND_LETTER);
    }

    if (upper) {
      newText[FIRST_WORD] = newText[FIRST_WORD].charAt(FIRST_LETTER).toUpperCase() + newText[FIRST_WORD].slice(SECOND_LETTER);
    } else {
      newText[FIRST_WORD] = newText[FIRST_WORD].charAt(FIRST_LETTER).toLowerCase() + newText[FIRST_WORD].slice(SECOND_LETTER);
    }

    return newText.join('');
  }

  getRateBySegment(rate: any, segment: string, rate_type: string, risk: string, withoutFormat?: boolean, isPlazo?: boolean) {
    const rateBySegment = rate.find(seg => seg.segment_code === segment);
    const ratebyType = rateBySegment.rates.find(ratesProperties =>
      ratesProperties.rate_type === rate_type && ratesProperties.risk_category === risk);
    const taxRate = ratebyType.tax_rate;
    if (withoutFormat) {
      return taxRate;
    }
    return this.formatDecimnalNumbers(taxRate.value, taxRate.decimals, isPlazo);
  }

  formatDecimnalNumbers(number: number, decimals: number, isPlazo?: any) {
    if (isPlazo && number.toString().length > 4) {
      let tempNumber = number.toString().split('');
      tempNumber.splice(4);
      number = parseInt(tempNumber.join(''), 0);
    }
    decimals = decimals > 2 ? 2 : decimals;
    const numstring = number.toString().split('');
    if (numstring.length > decimals) {
      const numberReverse = numstring.slice().reverse();
      numberReverse.splice(decimals, 0, ',');
      return numberReverse.reverse().join('') + '%';
    }
    numstring.unshift('0,');
    return numstring.join('') + '%';
  }

  /**
   * retorna el codigo dependiendo el segmento
   *
   * *return the product code depending the segment id*
   * @param {string} segment_id
   * @returns {string}
   */

  getProductCodeBySegmentId(segment_id) {
    switch (segment_id) {
      case '343':
      case '345':
      case '346':
        return '122';
      case '347':
      case '348':
        return '128';
      default:
        return '129';
    }
  }

  validateDiacritialMask(value) {
    value = value.replace(/\./g, '');
    value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  mapBooleanData(value) {
    return !(value === ' ' || value === 'NO' || value === null);
  }

  unRegisterAplication(name: string) {
    unregisterApplication(name).then(() => {
      return true;
    });
  }

  formatDateCalendar(date: Date): string {
    return `${date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()}/` +
      `${(date.getMonth() + 1) <= 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)}/${date.getFullYear()}`;
  }
}
